import { heroPicks } from "@/mocks/heroPicks";
import SectionHeading from "./SectionHeading";

export default function Picks() {
  return (
    <section id="picks" className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="本季精选开箱"
          title="这一期最值得先拆的三样"
          desc="从本期盒子里挑出风味差异最大的三款做个对照：一款甜口、一款辣味、一款坚果，方便你判断自己更想从哪一类入手。"
        />

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {heroPicks.map((pick) => (
            <article
              key={pick.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={pick.image}
                  alt={`${pick.title}的插画展示`}
                  className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-flex items-center rounded-full bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-800">
                  {pick.tag}
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">
                  {pick.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {pick.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}